import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

//Crm
import CrmReducer from "./crm/reducer";

//Campaign
import CampaignReducer from "./campaign/reducer";

//Posts
import PostReducer from "./posts/reducer";

//News
import NewsReducer from "./news/reducer";

//Television
import TvReducer from "./tv/reducer";
import TvProgramReducer from "./tvprogram/reducer";
import TvNewsReducer from "./tvnews/reducer";

//NewsPosts
import NewsPostsReducer from "./newsposts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

// Dashboard Campaign
import DashboardCampaignReducer from "./dashboardCampaign/reducer";
import NotificationReducer from "./notifications/reducer";

// Getter — нэвтэрсэн session-оор цуглуулах тусдаа систем
import GetterReducer from "./getter/reducer";

const rootReducer = combineReducers({
    Campaign: CampaignReducer,
    Post: PostReducer,
    News: NewsReducer,
    Tv: TvReducer,
    TvProgram: TvProgramReducer,
    TvNews: TvNewsReducer,
    NewsPosts: NewsPostsReducer,
    Layout: LayoutReducer,
    Login: LoginReducer,
    Account: AccountReducer,
    ForgetPassword: ForgetPasswordReducer,
    Profile: ProfileReducer,
    Crm: CrmReducer,
    DashboardCampaign: DashboardCampaignReducer,
    Users: require("./users/reducer").default,
    Notifications: NotificationReducer,
    Getter: GetterReducer
});

export default rootReducer;